import React, { useEffect, useState } from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { subscribeLoading } from '../api/client';
import { useTheme } from '../context/ThemeContext';
import { getThemeColors } from '../utils/themeStyles';

// Indicateur de chargement GLOBAL : visible dès qu'au moins une requête réseau
// (apiFetch ou fetchs des contexts) est en vol. Pastille flottante non bloquante
// en haut de l'écran — n'empêche pas l'interaction.
export default function GlobalLoadingIndicator() {
  const { isDarkTheme } = useTheme();
  const colors = getThemeColors(isDarkTheme);
  const [active, setActive] = useState(false);

  useEffect(() => subscribeLoading(setActive), []);

  if (!active) return null;

  return (
    <View pointerEvents="none" style={styles.wrap}>
      <View style={[styles.pill, { backgroundColor: colors.surface, borderColor: colors.border }]}>
        <ActivityIndicator size="small" color={colors.primary} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    top: 12,
    left: 0,
    right: 0,
    alignItems: 'center',
    zIndex: 9999,
  },
  pill: {
    width: 40,
    height: 40,
    borderRadius: 20,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.18,
    shadowRadius: 6,
    elevation: 6,
  },
});
